<template>
    <div style="display:none;">
        <v-card ref="containerInfobox" class="customInfobox" tile>
            <v-list-item three-line>
                <v-btn absolute
                       dark
                       fab
                       top
                       right
                       x-small
                       color="pink" @click="closeInfobox()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <!--<v-img width="75" :src="this.cas.Image"></v-img>-->
                <v-card-text style="font-size:10px">
                    <div>
                        <v-list-item-title class="mb-2">
                            {{this.cas.Titre}}
                        </v-list-item-title>
                    </div>
                    <div><span class="font-weight-bold">{{ GetTrad(94) }} :</span> {{this.cas.EntrepriseDeveloppeuse}}</div>
                    <div><span class="font-weight-bold">{{ GetTrad(90) }} :</span><v-img style="display:inline-block;vertical-align:middle;margin-bottom: 0.20em;margin-right:0.20em" width="24" max-height="30" v-for="icon in cas.SecteurActiviteIcone" :key="icon" :src="icon"></v-img></div>
                </v-card-text>
                <v-card-actions>
                    <v-btn fab dark x-small absolute
                           color="primary" bottom right style="bottom:0" elevation="5">
                        <v-icon dark>mdi-eye</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-list-item>
        </v-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        props: {
            cas: Object,
        },
        data() {
            return {
                infoboxOptions: {
                    visible: false,
                }
            }
        },
        mounted() {

        },
        computed: {
            ...mapGetters({ GetCasUtilisation: 'GET_CAS_UTILISATION', GetTrad: 'Traduction/GET_BY_ID' }),
        }
    }
</script>

<style>
    .customInfobox {
        max-width: 325px;
        min-width: 325px;
        padding: 5px;
        font-size: 12px;
        pointer-events: auto !important;
        z-index:0;
    }
</style>